// material-ui
import {Typography} from '@mui/material';

// project imports
import MainCard from 'ui-components/cards/MainCard';

// ==============================|| SAMPLE PAGE ||============================== //

const NotFound = () => {
    return (
        <MainCard title="Page Not Found">
            <Typography variant="body2">
                404
            </Typography>
        </MainCard>
    );
};

export default NotFound;
